








import Vue from 'vue'
import { components } from './Contents'
import {
  PartnerServiceContract,
  Query,
  ServicePlanType,
} from '@/types/generated/graphql'
import PartnerServiceContractQuery from '@/graphql/partner/partnerServiceContract.gql'
import userHandler, {
  resourceNotFoundHandler,
} from '@/handler/GraphQLUserHandler'

type Computed = {
  type?: ServicePlanType
}

type Data = {
  serviceContract?: PartnerServiceContract
}

export default Vue.extend<Data, {}, Computed, {}>({
  name: 'ServiceHome',
  components: { ...components },
  computed: {
    type() {
      return this.serviceContract?.servicePlan?.type
    },
  },
  apollo: {
    serviceContract: {
      query: PartnerServiceContractQuery,
      variables() {
        return { id: this.$route.params.id }
      },
      update: ({ partnerServiceContract }: Query): PartnerServiceContract =>
        partnerServiceContract,
      error(err) {
        return userHandler(err.graphQLErrors, resourceNotFoundHandler)
      },
    },
  },
})
